import React from 'react'
import logo from './images/logoa.png';
export default function Navbar() {
  return (
    <div>
    <nav className="w-full  fixed top-0 h-18 lg:h-24 z-50 " style={{backgroundColor:'#2554c7'}}>
    <div className="flex px-3 justify-between lg:px-16 items-center">
    <div className="flex ">
    
    <a href="/" className="flex items-center">
    <img src={logo} className="lg:mr-1 lg:ml-5 lg:h-18 lg:w-16  h-12 w-12 sm:h-14" alt="CodeExampler Logo"/>
    <span className=" text-sm lg:text-xl font-bold text-white " >CODE EXAMPLER</span>
    </a>
    </div>    
    
    <div className="pt-3 flex justify-center justify-self-center" id="mobile-menu">
    <ul className="flex justify-center  items-center  ">
    
    <li>
    <a href="/" style={{textDecoration:"none"}} className="lg:py-2 lg:pr-4 lg:pl-3 text-white lg:text-xl text-base mr-2 ">Home</a>
    </li>

    <a href="/programming-language-to-learn"><button type="button" className="text-white bg-indigo-900 hover:bg-indigo-800 lg:text-xl text-base focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg lg:px-5  lg:py-2.5 lg:h-14 lg:w-44 h-12 w-28  text-center lg:mr-3 md:mr-0 ">Free Courses</button>
    </a>
    
    </ul>
    
    </div>
    </div>
    </nav>
    <div className='lg:mt-28 mt-20' ></div>
    </div>
  )
}
